import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import * as _ from 'lodash';
import { Dbindices } from '../../../../../../../core/entities/dbindices.model';
import { Dbmodels } from '../../../../../../../core/entities/dbmodels.model';
import { DbindicesService } from '../../../../../../../core/repositories/dbindices.service'
import { SelectItem } from 'primeng/api';
import { InternalHomeService } from '../../../../../internal-home/internal-home.service';

@Injectable()
export class EditDialogsDbindicesService {

  dbindices: Dbindices = new Dbindices();
  originalDbindices: Dbindices = new Dbindices();
  parametersInput: Dbindices = new Dbindices();

  optionsDbmodels: SelectItem[] = [];

  optionsDbmodelBase: SelectItem[] = [];

  allDbindices: Dbindices[] = [];
  changetitulo: boolean = false;

  dbmodels: Dbmodels[] = new Array<Dbmodels>();

  constructor(private dbindicesService: DbindicesService,
              private internalHomeService: InternalHomeService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.dbindices = data.dbindice;
    this.changetitulo = data.titulochange;
    this.originalDbindices = _.cloneDeep(this.dbindices);
    console.log(data);
    return forkJoin({
        valor0: this.dbindicesService.findAll(),
        valor1: this.internalHomeService.allDbmodels()}
    ).pipe(map(dataGroup => {
      this.allDbindices = dataGroup.valor0 as Dbindices[];
      this.dbmodels = dataGroup.valor1;

      this.optionsDbmodelBase.push({value: null, label: ""});

      for(let i = 0; i < this.dbmodels.length; i++){
        this.optionsDbmodelBase.push({value: this.dbmodels[i].code, label: this.dbmodels[i].code});
      }

      if (Utils.noUndfAndNull(data.dbindice)) {
        this.dbindices = _.cloneDeep(data.dbindice);
      }

      this.optionsDbmodels = this.optionsDbmodelBase;
      this.optionsDbmodelBase = [];

      return true;
    }),catchError((error: any) => {
      throw error;
    }));
  }


  /**
  * @description
  * Guarda el dbindice
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.dbindices.id, "")) {

      /*comparamos el dbindice original con el modificado*/
      let compareDbindice = this.compare(this.dbindices, this.originalDbindices);

      if(compareDbindice){
        return of(-1);
      }else{
        for(let i = 0; i < this.dbmodels.length; i++){
          if(this.dbindices.dbmodelId.code === this.dbmodels[i].code){
            this.dbindices.dbmodelId.id = this.dbmodels[i].id;
          }
        }
        return this.dbindicesService.postDbindice(this.dbindices);
      }

    }else{
      for(let i = 0; i < this.dbmodels.length; i++){
        if(this.dbindices.dbmodelId.code === this.dbmodels[i].code){
          this.dbindices.dbmodelId.id = this.dbmodels[i].id;
        }
      }
      return this.dbindicesService.postDbindice(this.dbindices);
    }
  }

  /**
  * @description
  * Comprueba si dos Dbindices son iguales.
  * @param datoX Dbindice 1
  * @param datoY Dbindice 2
  * @returns True si son iguales
  */
  public compare(itemX:Dbindices, itemY:Dbindices):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if (itemX.dbmodelId.code !== null) {
        let value = itemX.dbmodelId.code.toString();
        if (value === 'null') {
          itemX.dbmodelId.code = "";
        }
      }

      if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)
      || !Utils.compareTextOrNumber(itemX.dbmodelId.code, itemY.dbmodelId.code)
      || !Utils.compareTextOrNumber(itemX.ispk, itemY.ispk)
      || !Utils.compareTextOrNumber(itemX.isunique, itemY.isunique)
      || !Utils.compareTextOrNumber(itemX.description, itemY.description))
      && (itemX.code !== ""
      && (Utils.noUndfAndNull(itemX.dbmodelId.code) && itemX.dbmodelId.code !== "")))
        return false;
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
      return false;
    }
    return true;
  }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.dbindices = new Dbindices();
  }

}
